import { withStyles } from '@material-ui/core/styles';
import OneTabSimulation from './OneTabSimulation';
import styles from './OneTabSimulation.styles';

export default withStyles(styles)(OneTabSimulation);
